import store from './store'

const microApps = [
  {
    name: 'product_backend',
    entry: process.env.VUE_APP_SUB_PRODUCT_BACKEND,
    activeRule: '/productBackend'
  },
  {
    name: 'orderBackend',
    entry: process.env.VUE_APP_SUB_ORDER_BACKEND,
    activeRule: '/orderBackend'
  }
]

const apps = microApps.map(item => {
  return {
    ...item,
    container: '#subapp-viewport', // 子应用挂载的div
    props: {
      routerBase: item.activeRule, // 下发基础路由
      getGlobalState: store.getGlobalState // 下发getGlobalState方法
    }
  }
})

export default apps
